import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import routes from "../../routes";

const AppContent = () => {
  return (
    <div>
      <Suspense fallback={<div className="loading-wrap"></div>}>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            );
          })}
        </Routes>
      </Suspense>
    </div>
  );
};

export default AppContent;
